import React, { useState } from 'react';
import axios from 'axios';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch('https://flokisoft.com/youssefandlara/loginusher', {
        method: 'POST',
        headers: {
          Authorization: 'ZPJTjkUuhg%',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: username, password: password }),
      });
    
      // Check if the response is successful
      if (!response.ok) {
        throw new Error(`Login failed with status: ${response.status}`);
      }
    
      // Parse the response as JSON
      const data = await response.json();
    
      // Check if the response contains the required fields
      if (data.username && data.token) {
        localStorage.setItem('usherToken', data.token);
        alert('Login successful!');
        // You can navigate to another page here, e.g., using React Router
      } else {
        setError('Login failed. Please check your credentials.');
      }
    } catch (err) {
      // Log the error and show a user-friendly message
      console.error('An error occurred:', err);
      setError('An error occurred during login. Please try again.');
    }
    
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-transparent">
      <div className="bg-transparent p-8 rounded-lg shadow-md w-96">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Login</h2>
        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label htmlFor="username" className="block text-sm font-medium text-gray-700">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
              required
            />
          </div>
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
          <button
            type="submit"
            className="w-full bg-primary text-white py-2 px-4 rounded-md hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
